import React from 'react';
import { NoAuthNavBar } from 'stash/components/global/NoAuthNavBar';
import { Text, PrimaryButton, SmartLink, Layout } from '@stashinvest/ui';

const ResetPasswordSuccess = function (props) {
	return (
		<>
			<NoAuthNavBar />
			<Layout.PageWrap>
				<Layout.ContentWrap>
					<Text.H1 size={3} mb="s">
						Your password has been reset!
					</Text.H1>
					<Text mb="m">You can log in with your new password now.</Text>
					<PrimaryButton as={SmartLink} to="/log-in" mb="s">
						Log in to Stash
					</PrimaryButton>
					<Text align="center">
						<a
							href="https://ask.stash.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Need help?
						</a>
					</Text>
				</Layout.ContentWrap>
			</Layout.PageWrap>
		</>
	);
};

export default ResetPasswordSuccess;
